import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  anonymous: Yup.boolean(),
  guestName: Yup.string().when('anonymous', {
    is: false,
    then: (schema) =>
      schema
        .min(5, 'Polje mora da sadrži minimalno 5 karaktera.')
        .max(30, 'Polje može da sadrži maksimalno 30 karaktera.')
        .required('Unesite ime.'),
    otherwise: (schema) => schema.notRequired(),
  }),
  guestEmail: Yup.string().when('anonymous', {
    is: false,
    then: (schema) =>
      schema
        .email('Email nije ispravan.')
        .max(40, 'Polje može da sadrži maksimalno 40 karaktera.')
        .required('Unesite email.'),
    otherwise: (schema) => schema.notRequired(),
  }),
  guestNumber: Yup.string().when('anonymous', {
    is: false,
    then: (schema) =>
      schema
        .min(9, 'Broj telefona nije validan.')
        .required('Unesite broj telefona.')
        .matches(/^[+]?[0-9]*$/, 'Broj telefona nije validan.'),
    otherwise: (schema) => schema.notRequired(),
  }),
  address: Yup.string().max(
    40,
    'Polje može da sadrži maksimalno 40 karaktera.'
  ),
  description: Yup.string()
    .min(5, 'Polje mora da sadrži minimalno 5 karaktera.')
    .max(180, 'Polje može da sadrži maksimalno 180 karaktera.')
    .required('Unesite opis kvara.'),
  image: Yup.mixed()
    .notRequired()
    .test(
      'FILE_SIZE',
      'Veličina datoteke je prevelika. Maksimalna veličina datoteke je 10MB.',

      (value) => {
        if (!value || value === '') return true;
        return value && value.size < 1024 * 1024 * 10;
      }
    )
    .test(
      'FILE_TYPE',
      'Nepodržan format datoteke. Dozvoljeni su samo JPG, JPEG i PNG formati.',
      (value) => {
        if (!value || value === '') return true;

        return (
          value && ['image/png', 'image/jpeg', 'image/jpg'].includes(value.type)
        );
      }
    ),
});

export const initialValues = {
  anonymous: false,
  guestName: '',
  guestEmail: '',
  guestNumber: '',
  address: '',
  description: '',
  image: '',
};
